<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-active">搜索</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h4 id="title">搜索</h4>
          <div id="searchBar">
            <div id="searchInput">
              <input id="searchContent">
              <b-img
                  id="searchDrop"
                  :src="greenArrowImg"></b-img>
            </div>
            <button id="searchButton">搜索</button>
          </div>
          <b-table id="searchRes" striped hover :items="items">
            <template v-slot:cell(预约接种)="data">
              <a :href="data.value">选择医院</a>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Search",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      greenArrowImg: common.greenArrowImgSrc,
      assistImg: common.assistImgSrc,
      items: []
    }
  },
  mounted() {
    common.assureLogin(this);
    document.querySelector("#searchButton").onclick = ()=>{
      this.axios.post(common.apiBase + common.apiService.search, {
        'token': localStorage.getItem("loginToken"),
        'data': {
          'keyword':document.querySelector("#searchContent").value,
        }
      }).then((res) => {
        for (let i of res.data.data) {
          this.items.push({
            '疫苗全称':i['name'],
            '防疫疾病':i['disease'],
            '价格':i['cost'],
            '时效':i['effective_time'],
            '建议接种时间':i['advised_time'],
            '预约接种':'#/appnewv/'+i['vtid']
          });
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>

#title {
  margin-top: 30px;
  margin-left: 5%;
}

#searchBar {
  margin-top: 30%;
  transform: translateY(-60%);
  margin-left: 15%;
  width: 80%;
}

#searchRes {
  margin-top: 30px;
}

#searchInput {
  display: inline-block;
  position: relative;
  width: 70%;
  height: 40px;
  border: mediumaquamarine solid 1px;
  border-radius: 25px;
  overflow: hidden;
}

#searchContent {
  width: 80%;
  height: 40px;
  border: none;
  padding-left: 6%;
}

#searchContent:focus {
  outline: none;
}

#searchDrop {
  position: absolute;
  right: 5%;
  top: 15px;
  width: 18px;
}

#searchButton {
  position: absolute;
  display: inline-block;
  top: 40%;
  transform: translateY(-50%);
  right: 10%;
  height: 40px;
  width: calc(20% - 10px);
  background: mediumaquamarine;
  color: white;
  border: none;
  outline: none;
  padding: 10px 20px;
  border-radius: 20px;
}
</style>